<template lang="">
    <div>
            <marquee
              id="marquee"
              behavior="scroll"
              style="height: 17px; line-height: 17px"
              @mouseenter="marqueeChange(0)"
              @mouseleave="marqueeChange(1)"
            >
              <template>
                <span
                  style="margin-right: 40vw"
                  v-for="(item, index) in marqueeList"
                  :key="item.id"
                  >( {{ index + 1 }} ) {{ item.title }} ： {{ item.content }}
                </span>
              </template>
            </marquee>
    </div>
</template>

<script>
export default {
  props: ["marqueeList"],

  methods: {
    /**
     * 跑马灯方法
     */
    marqueeChange(val) {
      // debugger;
      let marquee = document.getElementById("marquee");
      if (val == 1) {
        marquee.start();
      } else {
        marquee.stop();
      }
    },
  },
};
</script>